import React from 'react';

export default ({required = false, label = null, htmlFor = null, children}) => (
	<dl className={'Field'+(required ? ' required' : '')}>
		<dt><label htmlFor={htmlFor}>{label}</label></dt>
		<dd>{children}</dd>
	</dl>
);